import km from "keymirror";
import _ from "underscore";

const env = process.env || "development";

export default _.extend(
  {
    /* 8	mobile	5	手机号	用户自定义发货字段手机输入项
  9	oilCard	5	油卡卡号	自定义发货字段油卡卡号输入项
  10	name	5	姓名	自定义发货字段性别输入项
  11	idCard	5	身份证	自定义发货字段身份证输入项
  12	address	5	地址	用户自定义发货字段地址输入项
  13	remark	5	其他	用户自定义发货字段其他输入项 */
    PREORDER_ATTR_ID_MOBILE: 8,
    PREORDER_ATTR_ID_OILCARD: 9,
    PREORDER_ATTR_ID_NAME: 10,
    PREORDER_ATTR_ID_IDCARD: 11,
    PREORDER_ATTR_ID_ADDRESS: 12,
    PREORDER_ATTR_ID_REMARK: 13,

    // 配送信息类型
    PREORDER_DELIVERY_TYPE_MOBILE: 1,
    PREORDER_DELIVERY_TYPE_OILCARD: 2,
    PREORDER_DELIVERY_TYPE_CARDNUMBER: 3,
    PREORDER_DELIVERY_TYPE_IDENTITY: 4,
    PREORDER_DELIVERY_TYPE_O2O: 5, // o2o配送类型
    PREORDER_DELIVERY_TYPE_CLEARANCE: 6, // 提供身份证清关
    PREORDER_DELIVERY_TYPE_NUMBER_CANDLE: 7,
    PREORDER_DELIVERY_TYPE_EXAMINE: 8, // 体检预约信息
    PREORDER_DELIVERY_TYPE_RECHARGE_ACCOUNT: 9, //  充值帐号Recharge account
    // 以下值对应 “配送信息类型” == 5的时候，infoNeed 的value值：
    PREORDER_DELIVERY_O2O_DELIVER: 1,
    PREORDER_DELIVERY_O2O_SELF: 2,
    PREORDER_DELIVERY_O2O_BOTH: 3,

    // 预约类型
    // 1系统预约 2人工预约
    PREORDER_EXAMINE_SYSTEM_TYPE: 1,
    PREORDER_EXAMINE_PERSON_TYPE: 2,

    // 体检状况:0 - 未预约，1 - 预约中（待审核），2 - 已预约，3 - 已到检，4 - 已取消，5 - 预约失败
    PREORDER_EXAMINE_STATUS_SUCCESS: 2,
    PREORDER_EXAMINE_STATUS_FAIL: 5,

    // 支付类型
    PREORDER_PAY_NO_CASH: 0,
    PREORDER_PAY_ALIPAY_WAP: 1,
    PREORDER_PAY_ALIPAY_APP: 11,
    PREORDER_PAY_WECHAT_WAP: 2,
    PREORDER_PAY_UNION_PAY: 3, // 银联支付
    PREORDER_PAY_WECHAT_PUBLIC: 20,
    PREORDER_PAY_WECHAT_APP: 21,
    PREORDER_WECHAT_MINI_PROGARM: 23, // 微信小程序支付
    PREORDER_PAY_UNION_PAY_APP: 31, // 吊起app的银联支付
    PREORDER_PAY_INSTALLMENT: 41, // 银联分期
    PREORDER_PAY_FENQILE: 6, // 分期乐支付
    PREORDER_WEBCHAT_PUBLIC_PAY_URL:
      env === "development"
        ? "http://batty.maizuo.com/pay/"
        : env === "preview"
        ? "http://pre-pay.sdyxmall.com/pay/"
        : "https://pay.sdyxmall.com/pay/",

    //错误状态码
    WECHAT_PUBLIC_ERROR: 6808005,
    //订单类型ordertype
    PREORDER_TYPE_FOR_SHOW_NORMAL: 1,
    PREORDER_TYPE_FOR_SHOW_FILM: 2,
    PREORDER_TYPE_FOR_SHOW_SHOUFA: 3,
    PREORDER_TYPE_FOR_SHOW_GROUPON: 4,
    PREORDER_TYPE_FOR_SHOW_CARDDELAY: 5,
    PREORDER_TYPE_FOR_SHOW_ID_CARD: 6,
    PREORDER_TYPE_FOR_SHOW_EXAMINE: 7, // 体检订单
    // 订单类型for 后端
    PREORDER_ORDER_TYPE_FOR_PAY_NORMAL: 0,
    PREORDER_ORDER_TYPE_FOR_PAY_GROUPON: 2,
    PREORDER_ORDER_TYPE_FOR_PAY_QIYEGOU: 4, // 用于企业购下单的类型
    PREORDER_ORDER_TYPE_FOR_PAY_EXAMINE: 7,
    //订单商品类型：productType
    PREORDER_PRODUCT_TYPE_ELECTRONIC_TICKET: 1, //电子票
    PREORDER_PRODUCT_TYPE_FILM_TICKET: 2, //订座票
    PREORDER_PRODUCT_TYPE_OIL_CARD: 3, //加油卡充值
    PREORDER_PRODUCT_TYPE_PHONE_COST: 4, //话费，
    PREORDER_PRODUCT_TYPE_NET_COST: 5, //流量
    PREORDER_PRODUCT_TYPE_EXCHANGE_CODE: 6, //兑换码
    PREORDER_PRODUCT_TYPE_NORMAL: 0, //普通商品
    PREORDER_PRODUCT_TYPE_CARDDELAY: 7, //卡延期商品
    PREORDER_PRODUCT_TYPE_SUPER_OIL_CARD: 8, // 超级油卡，用于超级卡消费
    PREORDER_PRODUCT_TYPE_SUPER_PHONE_COST: 9, // 超级话费，用于超级卡消费
    PREORDER_PRODUCT_TYPE_CAKE: 10, // 蛋糕专区的商品
    PREORDER_PRODUCT_TYPE_EXAMINE: 11, // 体检商品
    PREORDER_PRODUCT_TYPE_RECHARGE_ACCOUNT: 12, // 第三方充值商品
    PREORDER_PRODUCT_TYPE_COURSE: 13, // 课程商品
    PREORDER_PRODUCT_TYPE_COMBINATION_GOODS: 15, // 组合商品

    // sku 状态
    PREORDER_SKU_STATUS_LACK: 1, // 缺货

    //结算商品列表类型
    PRODUCT_GOODS_EXPRESS_FREESHIPPING: 1, // 包邮商品
    PRODUCT_GOODS_EXPRESS_NORMALSHIPPING: 0, //非包邮商品
    PRODUCT_GOODS_EXPRESS_SPECIAL: 2, // 普通运费商品
    PRODUCT_GOODS_EXPRESS_VIRTUAL: 3, // 虚拟商品免运费

    // 下单提示类型
    PREORDER_REMIND_TYPE_MESSAGE: 1, // 弹框提示

    // 地址提示类型
    CHECK_ADDRESS_MSG_TYPE_AREA_CONTROL: 1,
  },
  km({
    PREORDER_MATCHCARDTOTAL_SUCCESS: null,
    PREORDER_MATCHCARDTOTAL_ERROR: null,
    PREORDER_ORDERCARDCHECK_SUCCESS: null,
    PREORDER_ORDERCARDCHECK_ERROR: null,
    PREORDER_MATCHORDERCARDLIST_SUCCESS: null,
    PREORDER_MATCHORDERCARDLIST_ERROR: null,
    PREORDER_ORDERCARDLISTOPTIMAL_SUCCESS: null,
    PREORDER_ORDERCARDLISTOPTIMAL_ERROR: null,
    PREORDER_GETPREORDERINFO_SUCCESS: null,
    PREORDER_GETPREORDERINFO_ERROR: null,
    PREORDER_GETPREORDERSKUS_SUCCESS: null,
    PREORDER_GETPREORDERSKUS_ERROR: null,
    PREORDER_GETPREORDERSKUEXTEND_SUCCESS: null,
    PREORDER_GETPREORDERSKUEXTEND_ERROR: null,
    PREORDER_GETFILMORDER_SUCCESS: null,
    PREORDER_GETFILMORDER_ERROR: null,
    PREORDER_CREATEORDER_SUCCESS: null,
    PREORDER_CREATEORDER_ERROR: null,
    PREORDER_CASHPAY_SUCCESS: null,
    PREORDER_CASHPAY_ERROR: null,
    PREORDER_CANCELTICKETORDER_SUCCESS: null,
    PREORDER_CANCELTICKETORDER_ERROR: null,
    PREORDER_GETDESIGNATEDCARDS_SUCCESS: null,
    PREORDER_GETDESIGNATEDCARDS_ERROR: null,
    PREORDER_GETPAYLIMIT_SUCCESS: null,
    PREORDER_GETPAYLIMIT_ERROR: null,
    PREORDER_ORDERCOUPONLIST_SUCCESS: null,
    PREORDER_ORDERCOUPONLIST_ERROR: null,
    PREORDER_GETORDERCOUPONNUM_SUCCESS: null,
    PREORDER_GETORDERCOUPONNUM_ERROR: null,
    PREORDER_ORDEROPTIMALPAY_SUCCESS: null,
    PREORDER_ORDEROPTIMALPAY_ERROR: null,
    PREORDER_ORDERCHECKPAY_SUCCESS: null,
    PREORDER_ORDERCHECKPAY_SUCCESS_CONFIRM: null,
    PREORDER_ORDERCHECKPAY_ERROR: null,

    PREORDER_ORDERCHECKPAY_COUPON_ERROR: null,
    PREORDER_ORDERCHECKPAY_CARD_ERROR: null,
    PREORDER_ORDERCHECKPAY_BOTH_ERROR: null,

    PREORDER_CHECKLOGISTICS_SUCCESS: null,
    PREORDER_CHECKLOGISTICS_ERROR: null,
    PREORDER_GETSKULISTBYPREID_SUCCESS: null,
    PREORDER_GETSKULISTBYPREID_ERROR: null,
    PREORDER_GETGOODSBYPREID_SUCCESS: null,
    PREORDER_GETGOODSBYPREID_ERROR: null,
    PREORDER_PREORDERVERIFY_SUCCESS: null,
    PREORDER_PREORDERVERIFY_ERROR: null,
    PREORDER_GETCASHPAYWAY_SUCCESS: null,
    PREORDER_GETCASHPAYWAY_ERROR: null,
    PREORDER_CHANGEINVOICE_INPUT_SUCCESS: null,
    PREORDER_SETINVOICEINFO_SUCCESS: null,
    PREORDER_GETTIEDPRODUCT_SUCCESS: null,
    PREORDER_GETTIEDPRODUCT_ERROR: null,
    PREORDER_GETORDERSTORELIST_SUCCESS: null,
    PREORDER_GETORDERSTORELIST_ERROR: null,
    PREORDER_ONORDEREVENT_SUCCESS: null,
    PREORDER_ONORDEREVENT_ERROR: null,
    PREORDER_GETEXAMINEAGENCYLISTOFPREORDER_SUCCESS: null,
    PREORDER_GETEXAMINEAGENCYLISTOFPREORDER_ERROR: null,
    PREORDER_GETGIFTORDERSKUEXTEND_SUCCESS: null,
    PREORDER_GETGIFTORDERSKUEXTEND_ERROR: null,
    PREORDER_CHECKGIFTORDERLOGISTICS_SUCCESS: null,
    PREORDER_CHECKGIFTORDERLOGISTICS_ERROR: null,
    PREORDER_GETORDERREMINDMSG_SUCCESS: null,
    PREORDER_GETORDERREMINDMSG_ERROR: null,
    /*yeoman-template-point-1*/

    PREORDER_SESSION_STORAGE_SELECTED_ASSET: null,
  })
);
